<template>
  <nav class="font-weight-semi-bold">
    <ul
      :class="{'list-inline':isInline}"
      class="no-list main-nav m-0"
    >
      <li
        class="pb-2 pb-lg-0"
        :class="{'list-inline-item':isInline}"
        v-if="user.id"
      >
        <router-link
          class="d-flex align-items-center mr-2 text-black"
          :to="{
                        name: 'menuIndex',
                        params: { userSlug: user.slug }
                    }"
        >Menu</router-link>
      </li>
      <li
        class="pb-2 pb-lg-0"
        :class="{'list-inline-item':isInline}"
        v-if="user.id"
      >

        <router-link
          class="d-flex align-items-center mr-2 text-black"
          :to="{
                        name: 'userAssets',
                        params: { userSlug: user.slug }
                    }"
        >Menu QR</router-link>
      </li>
      <li
        class="pb-2 pb-lg-0"
        :class="{'list-inline-item':isInline}"
        v-if="user.id"
      >

        <router-link
          class="d-flex align-items-center mr-2 text-black"
          :to="{
                        name: 'userSmsCampaigns',
                        params: { userSlug: user.slug }
                    }"
        >SMS campaigns</router-link>
      </li>

      <li
        class="pb-2 pb-lg-0"
        :class="{'list-inline-item':isInline}"
        v-if="user.id && user.stripe_charges_enabled"
      >
        <router-link
          class="d-flex align-items-center mr-2 text-black orders"
          :to="{
                        name: 'userOrders',
                        params: { userSlug: user.slug,status:'new' }
                    }"
        >Orders<div class="order-count bg-danger">
            <div>{{orderCount}}</div>
          </div></router-link>
      </li>

      <li
        class="pb-2 pb-lg-0"
        :class="{'list-inline-item':isInline}"
        v-if="user.id && user.stripe_charges_enabled"
      >
        <router-link
          class="d-flex align-items-center mr-2 text-black orders"
          :to="{
                        name: 'userFeedback',
                        params: { userSlug: user.slug}
                    }"
        >Feedback<div class="order-count bg-danger">
            <div>{{feedbackCount}}</div>
          </div></router-link>
      </li>
      <li
        class="pb-2 pb-lg-0"
        :class="{'list-inline-item':isInline}"
        v-if="user.id && user.stripe_charges_enabled"
      >
        <router-link
          class="d-flex align-items-center mr-2 text-black orders"
          :to="{
                        name: 'userCustomers',
                        params: { userSlug: user.slug}
                    }"
        >Customers</router-link>
      </li>

      <li
        class="pb-2 pb-lg-0"
        :class="{'list-inline-item':isInline}"
        v-if="user.id && user.guest_register==1"
      >
        <router-link
          class="d-flex align-items-center mr-2 text-black"
          :to="{
                        name: 'userGuests',
                        params: { userSlug: user.slug }
                    }"
        >Contact tracing</router-link>
      </li>

      <li
        class="pb-2 pb-lg-0"
        :class="{'list-inline-item':isInline}"
        v-if="user.id"
      >
        <router-link
          class="d-flex align-items-center mr-2 text-black"
          :to="{
                        name: 'userSettings',
                        params: { userSlug: user.slug }
                    }"
        >Settings</router-link>
      </li>
      <li
        class="pb-2 pb-lg-0"
        :class="{'list-inline-item':isInline}"
        v-if="user.id"
      >
        <a
          href="/docs"
          target="_blank"
          class="d-flex align-items-center mr-2 text-black"
        >
          Help</a>
      </li>
      <li
        class="pb-2 pb-lg-0 d-inline-flex align-items-center"
        :class="{'list-inline-item':isInline}"
        v-if="user.id"
      >
        <img
          v-if="loggingOut"
          src="/storage/images/svg-loaders/grid.svg"
          width="10"
          class="img-fluid"
        />
        <a
          class="d-flex align-items-center mr-2 text-black"
          :class="{'d-flex align-items-center mr-2 text-muted':loggingOut}"
          v-on:click="logout()"
        >
          Logout</a>
      </li>
    </ul>
  </nav>
</template>

<style lang="scss" scoped>
.logo {
  font-size: 1.5rem;
}
.orders {
  position: relative;
  display: inline-block;
  .order-count {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    top: -0.3rem;
    right: -0.7rem;
    width: 1.3rem;
    height: 1.3rem;
    padding: 0.5rem;
    border-radius: 50%;
    background-color: #000;
    font-size: 0.75rem;
    color: #fff;
    font-weight: 600;
  }
}
</style>

<script>
export default {
  mounted() {
    this.getOrderCount();
    this.getFeedbackCount();
    this.intervalId = setInterval(() => {
      this.getOrderCount();
    }, 300000);
  },
  destroyed() {
    clearInterval(this.intervalId);
  },
  data() {
    return {
      loggingOut: false,
      orderCount: 0,
      feedbackCount: 0,
      intervalId: null,
    };
  },
  methods: {
    logout() {
      if (this.loggingOut) {
        return false;
      }
      this.loggingOut = true;
      axios.get("/api/user/logout").then(
        (response) => {
          this.getUser().then((result) => {
            this.loggingOut = false;
            this.$emit("close-nav");
            if (this.$route.name !== "home") {
              this.$router.push({
                name: "home",
              });
            }
          });
        },
        (error) => {
          this.loggingOut = false;
          console.log(error.response.data);
        }
      );
    },
    getOrderCount() {
      if (!this.user.stripe_charges_enabled) {
        return false;
      }
      axios.get("/api/orders/new/count").then(
        (response) => {
          this.orderCount = response.data;
        },
        (error) => {
          this.errors = error.response.data.errors;
        }
      );
    },
    getFeedbackCount() {
      if (!this.user.stripe_charges_enabled) {
        return false;
      }
      axios.get("/api/feedback/new/count").then(
        (response) => {
          this.feedbackCount = response.data;
        },
        (error) => {
          this.errors = error.response.data.errors;
        }
      );
    },
  },
  watch: {
    user(newValue, oldValue) {
      if (newValue.id) {
        this.getOrderCount();
        this.getFeedbackCount();
      }
    },
  },
  props: ["isInline"],
};
</script>
